module.exports = __webpack_public_path__ + "static/media/01_quote_mobile.e881746b.jpg";